import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { PHONE_NUMBER, PHONE_NUMBER_DISPLAY, trackPhoneClick } from '../utils/tracking';

const Hero = ({ t, language, backgroundImage }) => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePhoneClick = () => {
    trackPhoneClick();
    window.location.href = `tel:${PHONE_NUMBER}`;
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image - Full Cover */}
      <div className="absolute inset-0 z-0">
        <img
          src={backgroundImage || "/images/hero.webp"}
          alt="Montréon Fleet"
          className="w-full h-full object-cover"
        />
        {/* Overlay - mobile: full cover, desktop: left-to-right fade */}
        <div className="absolute inset-0 md:hidden" style={{ backgroundColor: 'rgba(255,255,255,0.80)' }}></div>
        <div className="absolute inset-0 hidden md:block" style={{ background: 'linear-gradient(to right, rgba(255,255,255,0.97) 0%, rgba(255,255,255,0.90) 35%, rgba(255,255,255,0.60) 60%, rgba(255,255,255,0) 100%)' }}></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 z-10 pt-28 pb-20">
        <div className="max-w-2xl">
          {/* Tagline */}
          <p className="text-[#10B981] text-sm font-semibold tracking-[0.15em] uppercase mb-4">
            European House of Mobility
          </p>
          
          {/* Main Headline */}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0D1B3E] mb-2 leading-tight">
            {t.hero.title}
          </h1>
          <p className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0D1B3E] mb-4">
            {t.hero.subtitle}
          </p>

          {/* Description */}
          <p className="font-body text-lg text-gray-600 mb-8 leading-relaxed max-w-lg">
            {t.hero.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 mb-8">
            <Button
              onClick={() => scrollToSection('booking')}
              data-testid="hero-cta-primary"
              className="w-full sm:w-auto bg-[#10B981] hover:bg-[#0EA472] text-white font-semibold px-8 h-14 text-base rounded shadow-lg hover:shadow-xl transition-all justify-center"
            >
              {t.hero.cta}
              <ArrowRight className="ml-2" size={18} />
            </Button>
            
            <Button
              onClick={handlePhoneClick}
              data-testid="hero-phone-cta"
              className="w-full sm:w-auto bg-[#0D1B3E] hover:bg-[#1A3A6B] text-white font-semibold px-8 h-14 text-base rounded shadow-lg hover:shadow-xl transition-all justify-center"
            >
              <Phone size={18} className="mr-2" />
              {PHONE_NUMBER_DISPLAY}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
